import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationLocationPvConstants {
    static STEP_TITLE = "Location";
    static ZONE_LABEL = "Zone";
    static NAME_FORM_CONTROL_NAME = "Block name.";
    static VALUATION_BLOCK_PROPERTIES = "valuationBlockProperties";
    static SALES_AREA_PROPERTIES = "salesAreaProperties";
    static VALUATION_BLOCK_SHAPE = "shape";
    static SALES_AREA_SHAPE = "salesAreaShape";
    static RESET_BLOCK = "Reset block";
    static SAVE_LABEL = "Update property";
    static DESCRIPTION_LABEL_1 = "Select the polygon tool from the toolbar.";
    static DESCRIPTION_LABEL_2 = "Draw a polygon on the map around the properties you wish to add to the valuation block or the sales area.";
    static WARNING_MESSAGE_NO_APPLICATION_TYPE = "Please select a valuation method, application type, valuation run and property type from the 'Details' tab before selecting properties";
    static REMOVE_DIALOG_TEXT = `${SharedConstants.REMOVE_TITLE} property`;
    static VALIDATION_MESSAGES = {
        blocks: {
            required: `Block ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        selectedGeometry: {
            required: `A geometry selection ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
    static NO_BLOCK_SELECTED_LABEL = "No block selected";
    static NO_PROPERTY_SELECTED_LABEL = "No property selected";
    static SELECTED_BLOCK_LABEL = "Selected block";
    static SELECTED_PROPERTY_LABEL = "Selected property";
    static INVALID_PROPERTY_ATTRIBUTE = "Some property attribute(s) are missing on the property layer. Please contact your systems administrator.";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static NO_PROPERTY_SELECTION_LAYER = "Property" + SharedConstants.NO_SELECTION_LAYER_SELECTED;
    static NO_ZONE_SELECTION_LAYER = "Zone" + SharedConstants.NO_SELECTION_LAYER_SELECTED;
}
